import { useState, useEffect } from 'react';
import Axios from "axios";
import { GetJobRoles, GetJobPosts, siteURL,updateStatus,GetCountries, Searchfilter } from '../../apiconstants/constants';
import { Link, useLocation,useNavigate} from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../../helpers/loadingspinner';
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png";
import ConsultantLayout from '../../commonlayouts/consultantlayout';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useCountry } from '../../contexts/countrycodecontext.js';
import { useForm } from "react-hook-form";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}

const GetCandidatesListByEmployerID = () => {
  const [offset, setOffset] = useState(0);
  let query = useQuery();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'  
const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [jobRoles, setJobRoles] = useState([]);
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showModal,setShowModal] = useState(false)
  const [showFilterModal,setShowFilterModal] = useState(false)
  const [candidateId, setCandidateId] = useState(null);
  const [hasNoData, setHasNoData] = useState(false);
  const { selectedCountry} = useCountry();
    const [jobPosts, setJobPosts] = useState([]);
  const token = localStorage.getItem("jwtToken");
    console.log("46",selectedCountry)
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
const fileName = "CandidatesList"; 
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")

const roleID = localStorage.getItem("roleID")
const appliedfilter = localStorage.getItem("candidateFilters")
if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}

  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [workmodeOptions] = useState([
    { value: "", label: "Select Work Mode" },
    { value: "1", label: "Work from Home" },
    { value: "2", label: "Work from Office" },
    { value: "3", label: "Hybrid" },
  ]);
     const [candidateType,setCandidateType] = useState([
          {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
          {candidateTypeID:"C2C",typeName:"C2C"},
          {candidateTypeID:"W2",typeName:"W2"},
        {candidateTypeID:"1099",typeName:"1099"}]);
  const { register, control, formState: { errors, isSubmitting }, setValue, reset } = useForm();
    const [selectedWorkMode, setSelectedWorkMode] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountryfilter, setSelectedCountry] = useState(null);
  const visaOptions = [
  { value: "US Citizen", label: "US Citizen" },
  { value: "Green Card", label: "Green Card (Permanent Resident)" },
  { value: "H1B", label: "H1B" },
  { value: "H1B Transfer", label: "H1B Transfer" },
  { value: "H4 EAD", label: "H4 EAD" },
  { value: "L1", label: "L1" },
  { value: "L2 EAD", label: "L2 EAD" },
  { value: "TN Visa", label: "TN Visa" },
  { value: "E3", label: "E3" },
  { value: "EAD", label: "EAD (Employment Authorization Document)" },
  { value: "OPT", label: "OPT (F1)" },
  { value: "CPT", label: "CPT (F1)" },
  { value: "Asylum EAD", label: "Asylum EAD" },
  { value: "Refugee EAD", label: "Refugee EAD" },
  { value: "TPS", label: "TPS (Temporary Protected Status)" },
  { value: "Other", label: "Other" },
];
  const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
     { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, // Default case

  ];
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined") 
    ? "" 
    : value;
 const currencyValue = (value, selectedCountry) => {
  const cleanedValue = safeValue(value).toString().replace(/[^0-9]/g, "");
  if (selectedCountry === 2 && cleanedValue !== "") {
    return `$${cleanedValue}`;
  }
  return cleanedValue;
};
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    FullName: "",
    Email: "",
    WorkAuthorizationandValidity: "",
    TechnicalSkill: "",
    PreferLocation: null,
    WorkMode: null,
    jobRoleId: "",
    UpdatedDate: null,
    // CountryID:selectedCountry,
    Address:"",
    CandidateType: "",
    jobTitleID: null
  
  });
 const [showMailModal, setShowMailModal] = useState(false);
const [selectedOptions, setSelectedOptions] = useState({
  sendJobDetails: true,
  sendRTR: false,
  sendFollowup: false,
});
const [selectedCandidate, setSelectedCandidate] = useState({
  fullName: "",
  email: ""
});


const handleMailRadioChange = (e) => {
  const { value } = e.target;

  setSelectedOptions({
    sendJobDetails: value === "sendJobDetails",
    sendRTR: value === "sendRTR",
    sendFollowup: value === "sendFollowup",
    sendRelocate: value === "sendRelocate"
  });
};
 


const handleConfirm = () => {
  const { fullName, email } = selectedCandidate;

  let emailType  = "jobdetails"; // default

  if (selectedOptions.sendRTR) emailType  = "rtr";
  else if (selectedOptions.sendFollowup) emailType  = "followup";
  else if (selectedOptions.sendRelocate) emailType  = "Relocate";
 navigate('/Employer/SendEmail', {
    state: {
      fullName,
      candidateEmail: email,
      emailType,
      candidateguid:guid
    },
  });
};

    const handleInputChange = (e) => {
      const { name, value } = e.target;
    
      setFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value, // Updates any input field dynamically
      }));
    };
    const handleAddressSearch = (e) => {
      const { name, value } = e.target;
    
      setFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value, // Updates any input field dynamically
      }));
    };
    const handleFilterChange = (selectedOption) => {
      setSelectedDateFilter(selectedOption); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        UpdatedDate: selectedOption.label, // ✅ Store label for API
      }));
    };


    const fetchJobPosts = async (jobRoleId, vendorGuid) => {
      setIsLoading(true);
      try {
        const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Filter based on selected Job Role and Vendor (client)
        const filteredPosts = response.data?.filter((x)=>x.status =='Active')
            console.log(filteredPosts)
    
        setJobPosts(filteredPosts);
      } catch (error) {
        console.error("Error fetching job posts", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    
useEffect(() => {
  GetCandidateList();
  fetchJobRoles();
  fetchCountries();
  fetchJobPosts();
}, [selectedCountry]); // Fetch data only once when the component mounts

const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
    console.error("Error fetching job roles", error);
  }
};
const fetchCountries = async () => {
  try {
    const response = await fetch(GetCountries.APIURL,
      { headers: {   
             Authorization: `Bearer ${token}`,
            }}
    );
    const json = await response.json();
    
    // Format the countries for react-select
    const countryOptions = json.map((country) => ({
      value: country.countryID, // Assuming each country has a unique ID
      label: country.country, // Adjust based on API response structure
    }));

    setCountries([{ value: "", label: "Select Country" }, ...countryOptions]);
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const handleViewToggle = (type) => {
  setViewType(type);
  setShowIcon(type)
};

const handleDeactivateCandidate = (id) => {
  setCandidateId(id);
  setShowModal(true)
};
const jobRoleOptions = jobRoles.map((item) => ({
  value: item.jobRoleId,
  label: item.jobRole
}));
const handleConfirmDeactivation = async () => {

   const params = {
      userGuid: Guid
    };

     await Axios.put(`${updateStatus.APIURL}?Guid=${candidateId}&isActive=${false}`, params,
      { headers: { Authorization: `Bearer ${token}` } }
     )
      .then((result) => 
        {
          if(result.data=='Candidate status updated successfully'){
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'DeActivated succesfully',
              showConfirmButton: false,
              timer: 2000,
            })
          }
          setCandidateData(prevData => prevData.filter(candidate => candidate.guid !== candidateId));

        setIsLoading(false);
        setShowModal(false);

      })
      .catch((error) => {
        console.log("Error" + error);
      });
    }



const handleCancel = () => {
  setShowModal(false);
};

const handleCancelSearch = () => {
  setShowFilterModal(false);
};
 const GetCandidateList = async () => {
  try {
    setIsLoading(true); // Show loader immediately
 
    const GetapiUrl = Searchfilter.APIURL;
    console.log("🌍 Selected Country:", selectedCountry);
 
    const savedFilters = localStorage.getItem("candidateFilters");
    let payload;
 
    if (savedFilters) {
      const parsedFilters = JSON.parse(savedFilters);
      parsedFilters.CountryID = selectedCountry;
      setFilters(parsedFilters);
 
      payload = {
        json: JSON.stringify(parsedFilters),
        type: "candidatepool",
      };
    } else {
      payload = {
        json: JSON.stringify({ UserGuid: Guid, CountryID: selectedCountry }),
        type: "candidatepool",
      };
    }
 
    // ✅ Wait for Axios completely
    const response = await Axios.post(GetapiUrl, payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
 
    console.log("✅ API success, data length:", response.data?.length);
 
    if (Array.isArray(response.data)) {
      setCandidateData(response.data);
    } else {
      setCandidateData([]);
    }
  } catch (error) {
    console.error("❌ Error fetching candidate list:", error);
    setCandidateData([]); // Ensure UI resets on failure
  } finally {
    // ✅ Stop loader only after everything finishes
    setIsLoading(false);
    console.log("🔵 Loader stopped");
  }
};
 
  const handleFilterSearch=()=>{
    setShowFilterModal(true);
    }
    const handleJobRoleChange = (selectedOptions) => {
      const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", "); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        jobRoleId: jobRolesLabels, // ✅ Store as a string
      }));
    };
    
    
    
    const handleWorkModeChange = (selectedOption) => {
      setSelectedWorkMode(selectedOption);
      
      setFilters((prevFilters) => ({
        ...prevFilters,
        WorkMode: selectedOption.label, // ✅ Store label for API
      }));
    };
    
   
    
    
    const applyFilters = () => {
      const cleanedFilters = {

        ...filters,
        // PreferLocation: filters.PreferLocation === "Select Country" ? "" : filters.PreferLocation,
        WorkMode: filters.WorkMode === "Select Work Mode" ? "" : filters.WorkMode,
        UpdatedDate: filters.UpdatedDate === "Select Date Filter" ? "" : filters.UpdatedDate,
        CountryID: selectedCountry ,

      };
    
      // Remove empty values
      let filteredData = Object.fromEntries(
        Object.entries(cleanedFilters).filter(
          ([key, value]) =>
            value !== "" &&
            value !== null &&
            !(Array.isArray(value) && value.length === 0)
        )
      );
       localStorage.setItem("candidateFilters", JSON.stringify(cleanedFilters));
      const payload = {
        json: JSON.stringify(filteredData),
        type: "candidatepool",
      };
  
      console.log("Sending JSON:", payload);
      Axios
        .post(Searchfilter.APIURL, payload,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((response) => {
          console.log("Success:", response.data);
             setShowFilterModal(false)
          if(response.data == "No Data"){
            setCandidateData([]);
          }
          else {
          setCandidateData(response.data)
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };
    const exportToCSV = async (fileName) => {
      setIsLoading(true); // Show loader while fetching data
    
      try {
        const GetapiUrl = Searchfilter.APIURL;
  
        const payload = {
          json: JSON.stringify({UserGuid: Guid,CountryID:selectedCountry}),
          type: "candidatepool",
    
        };
        const result = await Axios.post(GetapiUrl, payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setIsLoading(false);
    
        if (!result.data || result.data.length === 0) {
          alert("No data available for export.");
          return;
        }
    
        // Map API response to formatted data
        const customHeadings = result.data.map((item) => ({
          "Full Name": item.fullName,
          "Email": item.email,
          "Mobile Number": item.mobileNumber,
          "Gender": item.gender,
          "Address": item.address,
          "Date of Birth": item.dob,
          "Job Role": item.jobRoleName,
          "Marital Status": item.maritalStatus,
          "Technical Skill": item.technicalSkill,
          "Experience": item.experience,
          "Work Mode": item.workMode,
          "Prefer Location": item.preferLocation,
          "Profile Summary": item.profileSummery,
          "Bill Rate": item.billRate,
          "Work Authorization and Validity": item.workAuthorizationandValidity,
          "Employer Name": item.employerName,
          "SSN": item.ssn,
          "Passport No": item.passportNo,
          "Two References from Recent Project": item.tworefrencesfromrecentproject,
        }));
    
        // Convert JSON to sheet
        const ws = XLSX.utils.json_to_sheet(customHeadings);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    
        // Create Blob and trigger download
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
      } catch (error) {
        setIsLoading(false);
        console.error("Error exporting data:", error);
        alert("Failed to export data. Please try again.");
      }
    };

    const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription // Store job description for later use
      }));
useEffect(() => {
  setOffset(0); // when search term changes
}, [searchTerm]);

  useEffect(() => {
  const filteredData = candidateData?.filter(candidate => {
    const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();

    // If no search term
    if (!lowerSearchTerm) {
        return true; 
    }

    // Determine search logic based on operators
    let searchTerms;
    let isAndSearch = false;
  
    if (lowerSearchTerm?.includes(' + ') || lowerSearchTerm?.includes(' and ')) {
        searchTerms = lowerSearchTerm?.split(/\s*\+\s*|\s+and\s+/);
        isAndSearch = true; // ALL terms must match
    } else if (lowerSearchTerm.includes(' or ')) {
        searchTerms = lowerSearchTerm?.split(/\s+or\s+/);
        isAndSearch = false; // At least one term must match
    } else {
        searchTerms = [lowerSearchTerm]; // Treat it as a single phrase
        isAndSearch = false;
    }
  
    // Convert search terms to lowercase and trim spaces
    searchTerms = searchTerms.map(term => term.trim());
  
    // Function to check if a field contains the *entire search term*
    const fieldMatchesTerm = (term) => {
        return [
            candidate.fullName,
            candidate.technicalSkill,
            candidate.jobRoleName,
            candidate.preferLocation,
            candidate.address,
            candidate.profileSummary,
            candidate.workAuthorizationandValidity,
            candidate.email
        ].some(field => field?.toLowerCase()?.includes(term)) ||
        (candidate.experience !== undefined && 
         (candidate.experience?.toString()?.includes(term) || `${candidate.experience} years`?.includes(term)));
    };
  
    // Apply AND / OR search logic
    const matchesSearch = isAndSearch
        ? searchTerms.every(fieldMatchesTerm) // Require all terms to match (AND search)
        : searchTerms.some(fieldMatchesTerm); // At least one term matches (OR search)

    return matchesSearch;
  });
  if (filteredData.length === 0) {
    setHasNoData(true);
    setData([]); // clear the UI
    setPageCount(0);
    return;
  } else {
    setHasNoData(false);
  }
  const getExperienceText = (experience) => {
    if (!experience) return '';
    return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
  };
    const slice = filteredData.slice(offset, offset + perPage);
      setPageCount(Math.ceil(filteredData.length / perPage));
    const items = viewType =='grid' ? slice.map((data) => {
      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
             <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 550, height: 550, borderRadius: 20 }}>
                <div className='card-header' style={{ background: "none", minHeight: 100 }}>
                  <div className='row'>
                    <div className='col-4'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Pic</Tooltip>)}>
                        <img alt="Profile Photo" src={(data?.photo === "null") || (data.photo === null )?defaultimg : data?.photoURL} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} />
                        {/* <img alt="Profile Photo" src={defaultimg} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} /> */}

                      </OverlayTrigger>
                    </div>
                    <div className='col-8'>
                 
                   <Link style={{ float:"right" }} to={"/Employer/ReplicateBenchCandidate?guid=" + data.guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Replicate Candidate</Tooltip>)}>
                        <button style={{ background: "none", border: "none" }}><i className="fa fa-clone mt-2" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                      </OverlayTrigger>
                    </Link>
  
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{data.jobRoleName}</h5>
                      </OverlayTrigger>
                      
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{minHeight:180}}>
                                 
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                    <p style={{ fontSize: 14, textAlign: 'justify' }}>
                      <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-code" aria-hidden="true"></i>
                      {substring_str(data.technicalSkill)}
                    </p>
                  </OverlayTrigger>
              
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i> {data.mobileNumber} </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>               
                  {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{ selectedCountry == 2 ? "PayRate" : "Current CTC" }</Tooltip>)}>
                  <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-dollar-sign" aria-hidden="true"></i>{safeValue(data.payRate)}</p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>   { selectedCountry == 2 ? "BillRate" : "Expected CTC" } </Tooltip>)}>
                   <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-money-bill" aria-hidden="true"></i> {safeValue(data.billRate)}</p>
                 </OverlayTrigger> */}
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Sourced By</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i> {data.createdBy}</p>
                  </OverlayTrigger>     
                  {data.address!==null && data.address!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Address</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-map-marker" aria-hidden="true"></i> {cleanAddress(data.address)}  </p>
                  </OverlayTrigger>)}
                  {data.experience!==null && data.experience!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Experience</Tooltip>)}>
        <p style={{ fontSize: 14 }}><i className="fa fa-briefcase icons" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} ></i> {getExperienceText(data.experience)}</p>
                  </OverlayTrigger>)}
                  {data.workMode!==null && data.workMode!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Work Mode</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-home fa-building" aria-hidden="true"></i> {data.workMode} </p>
                  </OverlayTrigger>)}
                  {selectedCountry == 2 &&
  data.workAuthorizationandValidity !== null &&
  data.workAuthorizationandValidity !== "null" && (
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>
          Current Visa & First US Entry
        </Tooltip>
      )}
    >
      <p style={{ fontSize: 14 }}>
        <i
          style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
          className="fas fa-cogs"
          aria-hidden="true"
        ></i>
        {data.workAuthorizationandValidity}
      </p>
    </OverlayTrigger>
  )
  }
<OverlayTrigger
  placement="bottom"
  overlay={(props) => (
    <Tooltip id="tooltip" {...props}>
      Updated Date ({selectedCountry == 2 ? "MM/DD/YYYY" : "DD/MM/YYYY"})
    </Tooltip>
  )}
>
  <p style={{ fontSize: 14 }}>
    <i
      style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
      className="fas fa-calendar-alt"
      aria-hidden="true"
    ></i>
    {data.updateddate
    ? new Date(data.updateddate).toLocaleDateString(
        selectedCountry == 2 ? "en-US" : "en-GB"
      )
    : ""}
  </p>
</OverlayTrigger>

                </div>
                <div   className={`card-footer text-center`} 
  style={{ background: "none" }}
>       
        
  
                    <Link style={{ }} to={"/Employer/ViewCandidateDetailsByCandidate?guid=" + data.guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> View</Tooltip>)}>
                        <button style={{ background: "none", border: "none" }}><i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                      </OverlayTrigger>
                      
                    </Link>
            
                     <>
                     {/* <Link style={{}} to={"/Employer/ShareDetailstoVendor?guid=" + data.guid}>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Share</Tooltip>)}>
                    <button style={{ background: "none", border: "none" }}><i className="fa fa-share-alt" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                  </OverlayTrigger>
                </Link> */}
                {/* <OverlayTrigger
  placement="bottom"
  overlay={(props) => <Tooltip id="tooltip" {...props}>Send Email</Tooltip>}
>
  <button
    style={{ background: "none", border: "none" }}
    onClick={() => {
      setSelectedCandidate({
        fullName: data.fullName,
        email: data.email
      });
      setShowMailModal(true);
    }}
  >
    <i className="fa fa-envelope" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
  </button>
</OverlayTrigger> */}

{/* <Link style={{}}>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Dactivate Candidate</Tooltip>)}>
                      <button onClick={() => handleDeactivateCandidate(data.guid)} style={{ background: "none", border: "none" }}><i className="fa fa-ban" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
                    </OverlayTrigger>
                  </Link> */}
                  </>

                </div>
                
              </div>
        </div>
      )  })
      :
    
      <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
    <table  className="table" style={{fontSize: "12px", wordWrap: "break-word",  }}>
  <thead>
    <tr>
      <th style={{ padding: "4px" }}>Full Name</th>
      <th style={{ padding: "4px" }}>Job Role</th>
      <th style={{ padding: "4px" }}>Technical Skill</th>
      <th style={{ padding: "4px" }}>Mobile Number</th>
      <th style={{ padding: "4px" }}>Email</th>
      <th style={{ padding: "4px" }}>Address</th>
      <th style={{ padding: "4px" }}>Experience</th>
      <th style={{ padding: "4px" }}>Sourced By</th>
     {/* <th style={{ padding: "4px" }}>Work Mode</th>
     { selectedCountry == 2 ?<th style={{ padding: "4px" }}>PayRate</th>: <th style={{ padding: "4px" }}> Current CTC</th>}

     { selectedCountry == 2 ? <th style={{ padding: "4px" }}>Bill Rate</th>: <th style={{ padding: "4px" }}>Expected CTC</th>} */}
     {selectedCountry == 2 ?    <th style={{ padding: "4px" }}>Current Visa & First US Entry</th> : " " }
       <th style={{ padding: "1px" }}>
  Updated Date ({selectedCountry == 2 ? "MM/DD/YYYY" : "DD/MM/YYYY"})
</th>


      <th style={{ padding: "4px" }}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {slice?.map((data, index) => (
      <tr key={index}>
        <td style={{ padding: "4px" }}>{safeValue(data.fullName)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.jobRoleName)}</td>
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
             {safeValue(data.technicalSkill)}
            </Tooltip>
          )}
        >
          <td style={{ padding: "4px" }}>{safeValue(substring_str(data.technicalSkill))}</td>
        </OverlayTrigger>
        <td style={{ padding: "4px" }}>{safeValue(data.mobileNumber)}</td>
        <td style={{ padding: "4px"}}>{safeValue(data.email)}</td>
        <td style={{ padding: "4px"}}>{cleanAddress(data.address)}</td>
        <td style={{ padding: "4px"}}>{safeValue(data.experience)}</td>
        <td style={{ padding: "4px"}}>{safeValue(data.createdBy)}</td>
        {/* <td style={{ padding: "4px" }}>{safeValue(data.workMode)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.payRate)}</td>
        <td style={{ padding: "4px" }}>{safeValue(data.billRate)}</td> */}
          {selectedCountry == 2 ?  <td style={{ padding: "4px" }}>{safeValue(data.workAuthorizationandValidity)}</td> : " " }
     <td style={{ padding: "4px" }}>
  {data.updateddate
    ? new Date(data.updateddate).toLocaleDateString(
        selectedCountry == 2 ? "en-US" : "en-GB"
      )
    : ""}
</td>

       
        <td style={{ padding: "4px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              justifyContent: "center",
            }}
          >
            {/* Example of responsive button grouping */}
            {[
             
              {
                icon: "fa-eye",
                tooltip: "View",
                to: `/Employer/ViewCandidateDetailsByCandidate?guid=${data.guid}`,
              },
                        ].map((btn, i) => (
              <Link key={i} to={btn.to}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={(props) => (
                    <Tooltip id="tooltip" {...props}>
                      {btn.tooltip}
                    </Tooltip>
                  )}
                >
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      padding: "4px",
                    }}
                     onClick={btn.action}
                  >
                    <i
                      className={`fa ${btn.icon}`}
                      aria-hidden="true"
                      style={{ fontSize: 14, color: "#00a7ac" }}
                    ></i>
                  </button>
                </OverlayTrigger>
              </Link>
            ))}
            {/* Deactivate button (special case)
            <OverlayTrigger
              placement="bottom"
              overlay={(props) => (
                <Tooltip id="tooltip" {...props}>
                  Deactivate Candidate
                </Tooltip>
              )}
            >
              <button
                onClick={() => handleDeactivateCandidate(data.guid)}
                style={{ background: "none", border: "none", padding: "4px" }}
              >
                <i
                  className="fa fa-ban"
                  aria-hidden="true"
                  style={{ fontSize: 16, color: "#00a7ac" }}
                ></i>
              </button>
            </OverlayTrigger> */}
          </div>
        </td>



    
      </tr>
    ))}
  </tbody>
</table>

                            </div>
      
  

    setData(items);
  }, [offset, searchTerm,startDate,endDate,candidateData, perPage,viewType]);
useEffect(() => {
  const savedFilters = JSON.parse(localStorage.getItem("candidateFilters"));

  // Optional: Check for existence and apply to state or variables if needed
  if (savedFilters) {
    console.log("Loaded filters:", savedFilters);

    // Example: if you have state like setSearchTerm, setStartDate, etc.
    if (savedFilters.searchTerm) {
      setSearchTerm(savedFilters.searchTerm);
    }
    if (savedFilters.startDate) {
      setStartDate(savedFilters.startDate);
    }
    if (savedFilters.endDate) {
      setEndDate(savedFilters.endDate);
    }
    // ... any other filters
  }

  // Continue with your filtering logic...

}, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };

  const handleClick = () => {
    const finalURL = `${siteURL}/AddCandidate?uGuid=${Guid}&CountryID=${selectedCountry}`;
    navigator.clipboard.writeText(finalURL)
      .then(() => Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Copied',
        showConfirmButton: false,
        timer: 1000,
      }))
      
      
      .catch(err => console.error('Failed to copy URL: ', err));
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  const handleRefresh=()=>{
    setStartDate("")
    setEndDate("")
    setSearchTerm("")
    setFilters({
      UserGuid: Guid,
      FullName: "",
      Email: "",
      WorkAuthorizationandValidity: "",
      TechnicalSkill: "",
      PreferLocation: null,
      WorkMode: null,
      jobRoleId: "",
      UpdatedDate: null,
      CandidateType:"",
      jobTitleID: null
    });
    reset({ candidateTypeID: "", jobTitleID: null });

     localStorage.removeItem("candidateFilters");
    GetCandidateList();
  }

  const cleanAddress = (address) => {
  if (!address || address === "null") return "";
  return address.replace(/-\s*$/, "").trim();
};


  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      

<div class="responsive-container" style={{display:'flex',justifyContent:'space-between'}}>
        <div><h2 className="" style={{ color: "#00a7ac", marginLeft: '10px' }}>
    List of Candidates
  </h2></div>
<div style={{display:'flex',justifyContent:'space-between'}}>

              <div>

                 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Candidate</Tooltip>)}>
                <Link to="/Employer/AddCandidate">
                  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-plus"></i></button>
                </Link>
                 </OverlayTrigger>
                 <Link to={"/Employer/AddCandidatefromDocument?guid="+ guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Import candidate through PDF/Docx </Tooltip>)}>
                        <button className="btn btn-primary mr-3"><i className="fa fa-file" aria-hidden="true"></i></button>
                      </OverlayTrigger>
                 </Link>
            < OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Import Candidate List</Tooltip>)}>
              <Link to="/Employer/AddBulkCandidates">
              <button className="btn btn-primary mr-3" type="button" >
              <i class="fas fa-upload"></i>
                </button>
                </Link>
                </OverlayTrigger>
                 <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Outreach Candidates List</Tooltip>)}>
                <Link to="/Employer/OverallOutreachCandidates">
                  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fas fa-tachometer-alt"></i></button>
                </Link>
                 </OverlayTrigger>
                {(roleID === "2") &&
                 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Export To Excel</Tooltip>)}>
           <button className="btn btn-primary mr-3" onClick={(e) => exportToCSV(fileName)} type="button" >
           <i class="fas fa-file-excel" style={{fontSize:16}}></i>
                </button>
           </OverlayTrigger>}
                   <Link  to={"/Employer/ShareDetails?guid="+ guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Share to Client</Tooltip>)}>
                        <button className="btn btn-primary mr-3"><i className="fa fa-share-alt" aria-hidden="true"></i></button>
                      </OverlayTrigger>
                    </Link>
            {showIcon === 'grid' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                    <button
                                      className="btn btn-primary mr-3"
                                      onClick={() => handleViewToggle('list')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
              )}
              {showIcon === 'list' && (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                  <button
                    className="btn btn-primary mr-3"
                    onClick={() => handleViewToggle('grid')}
                    style={{ backgroundColor: "#00a7ac" }}
                  >
                    <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                  </button>
                </OverlayTrigger>
              )}
            <button className="btn btn-primary mr-3 mt-1" btn-ype="button" onClick={handleClick}>Copy URL</button>
           </div>
              
  
  </div>

        </div>
        <div>
 
        <div className="row d-flex justify-content-between mt-3">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technical Skill or Email or Role  or Address (Ex: AWS and Amazon S3)</Tooltip>
    )}>
      <input
        type="text"
        placeholder="Search by Name or Technical Skill or Email or Role or Country or Address (Ex: AWS and Amazon S3)"
        className="form-control mt-3"
        id="searchcss2"
        value={searchTerm}
        onChange={handleSearch}
      />
    </OverlayTrigger>
  </div>

  <div className="col-auto align-self-end">
   
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>{ appliedfilter == null ? "Apply Filter" : "Filter Applied" }</Tooltip>
    )}>
    <button className="btn btn-primary mt-3 mr-3" onClick={handleFilterSearch} style={{height:50}}type="button">
    <i className="fas fa-filter"></i>    { appliedfilter == null ? "Apply Filter" : "Filter Applied" }
    </button>
    </OverlayTrigger>
    </Link>
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Reset</Tooltip>
    )}>
    <button className="btn btn-primary mt-3" onClick={handleRefresh} style={{height:50}}type="button">
      <i className="fas fa-sync"></i> Reset Filter
    </button>
    </OverlayTrigger>
    </Link>
   
  </div>
</div>



              </div>
        <hr />
      
     {isLoading ? (
            <center><LoadingSpinner /></center>
          ) : (
            <>
   {hasNoData ? (
    <div className="pb-5 text-center">
      <img
        title="No Data"
        className="no-data-img"
        alt="no-data-img"
        src={nodataimg}
        style={{ height: 370 }}
      />
    </div>
  ) : (
    <div className="row mt-5 pb-3">
      {data}
    </div>
  )}
  
  
            </>
          )}
        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

<Modal show={showModal} style={{textAlign:"center"}} onHide={handleCancel}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Confirm Deactivation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to deactivate this candidate?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>No</Button>
          <Button variant="primary" onClick={handleConfirmDeactivation}>Yes</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal"  onHide={handleCancelSearch}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Filters </Modal.Title>
         </Modal.Header>
        <Modal.Body>
          <div className='row'>
                <div className='col-6'>               
               <OverlayTrigger
  placement="bottom"
  overlay={
    <Tooltip id="tooltip">
      Current Visa
    </Tooltip>
  }
>
  <div className="mt-3">
    <Select
      options={visaOptions}
      value={
        visaOptions.find(
          (opt) => opt.value === filters.WorkAuthorizationandValidity
        ) || null
      }
      styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 10,
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: "12px",
    }),
  }}
      onChange={(selected) =>
        handleInputChange({
          target: {
            name: "WorkAuthorizationandValidity",
            value: selected?.value || "",
          },
        })
      }
      placeholder="Select Current Visa"
      className="basic-form"
      isClearable
    />
  </div>
</OverlayTrigger>
                          
  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Date Filter</Tooltip>)}>    
 
                <Select
      options={dateFilterOptions}
      placeholder="Select Date Filter"
      value={dateFilterOptions.find(option => option.label === filters.UpdatedDate) || null}
      onChange={handleFilterChange}
      className="mt-3"
      styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 10,
          fontSize: "12px",
        }),
        placeholder: (provided) => ({
          ...provided,
          textAlign: "left",
          fontSize: "12px",
        }),
        singleValue: (provided) => ({
          ...provided,
          textAlign: "left",
          fontSize: "12px",
          
        }),
      }}
    />
    </OverlayTrigger>
      <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by  Address</Tooltip>
    )}>
         <input 
                          placeholder='Address'
                          type="text"
                          name="Address"
                          className="form-control basic-form mt-3 "
                          value={filters.Address}
                          onChange={handleAddressSearch}
                      />
    </OverlayTrigger>
    
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Candidate Type</Tooltip>)}>
                        <select  {...register("candidateTypeID")} className={`form-control mt-3`}
                        style={{height:50 ,borderRadius:15,fontSize:12}} 
                        value={filters.CandidateType || ""}
                           onChange={(event) =>
        setFilters((prevFilters) => ({
          ...prevFilters,
          CandidateType: event.target.value, // ✅ Store as a string
        }))
      }>
                <option value="">Select Candidate Type</option>
    {
      candidateType.map((item,index)=>
      {
        return(
    
       <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>
    
        );
      }
      
      )
    }
                        </select>
                                             </OverlayTrigger>   
                </div>
                <div className='col-6'>
             
    
                <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Technical Skills</Tooltip>)}>    
             
             <textarea 
                          placeholder='Technical Skills'
                          type=""
                          min="0"
                          title=''
                          row='5'
                          style={{height:115}}
                          name="TechnicalSkill"
                          value={filters.TechnicalSkill}
                          className="form-control basic-form mt-3 "
                          onChange={handleInputChange}
                      />
                </OverlayTrigger>
              <Select
            options={jobRoleOptions}
            isMulti
            placeholder="Select Job Roles"
            className="mt-3"
            value={jobRoleOptions.filter(option => 
              filters.jobRoleId.split(", ").includes(option.value.toString()) // ✅ Convert stored string back to array
            )}
            onChange={handleJobRoleChange}
            styles={{
              control: (provided) => ({
                ...provided,
                height: 115,
                borderRadius: 10,
                fontSize: "12px",
              }),
              placeholder: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
            }}
          />
   
                </div>
          </div>
         
        </Modal.Body>
        <Modal.Footer style={{marginTop:100}}>
        <Button variant="primary" onClick={handleRefresh}>
      <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
    </Button>
          <Button variant="primary" onClick={applyFilters}>Apply</Button>
          <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>

        </Modal.Footer>
      </Modal>
        <Modal
        show={showMailModal}
        onHide={() => setShowMailModal(false)}
        dialogClassName="custom-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#00a7ac" }}>Select Email Options</Modal.Title>
        </Modal.Header>
      
        <Modal.Body>
        <div className="form-check text-start ml-5">
  <input
    className="form-check-input"
    type="radio"
    name="mailType"
    value="sendJobDetails"
    checked={selectedOptions.sendJobDetails}
    onChange={handleMailRadioChange}
    id="sendJobDetails"
  />
  <label className="form-check-label" htmlFor="sendJobDetails">
    Send Job Details Mail
  </label>
</div>

<div className="form-check mt-2 text-start  ml-5">
  <input
    className="form-check-input"
    type="radio"
    name="mailType"
    value="sendRTR"
    checked={selectedOptions.sendRTR}
    onChange={handleMailRadioChange}
    id="sendRTR"
  />
  <label className="form-check-label" htmlFor="sendRTR">
    Send RTR Mail
  </label>
</div>

<div className="form-check mt-2 text-start  ml-5">
  <input
    className="form-check-input"
    type="radio"
    name="mailType"
    value="sendFollowup"
    checked={selectedOptions.sendFollowup}
    onChange={handleMailRadioChange}
    id="sendFollowup"
  />
  <label className="form-check-label" htmlFor="sendFollowup">
    Send Follow Up Mail
  </label>
</div>

<div className="form-check mt-2 text-start  ml-5">
  <input
    className="form-check-input"
    type="radio"
    name="mailType"
    value="sendRelocate"
    checked={selectedOptions.sendRelocate}
    onChange={handleMailRadioChange}
    id="sendRelocate"
  />
  <label className="form-check-label" htmlFor="sendRelocate">
    Send ReLocation Confirmation Mail
  </label>
</div>

        </Modal.Body>
      
        <Modal.Footer>
         
          <Button variant="primary" onClick={handleConfirm}>
            Proceed
          </Button>
           <Button variant="secondary" onClick={() => setShowMailModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </ConsultantLayout>
  );
}

export default GetCandidatesListByEmployerID;


